{
  "actionbar.actions": "Akce",
  "actionbar.actionsAvailable": "Dostupné akce.",
  "actionbar.clearSelection": "Vymazat výběr",
  "actionbar.selected": "{count, plural, =0 {žádné vybrané} other {# vybraných}}",
  "actionbar.selectedAll": "Vybráno vše",
  "breadcrumbs.more": "Další položky",
  "button.pending": "čeká na vyřízení",
  "combobox.noResults": "Žádné výsledky",
  "contextualhelp.help": "Nápověda",
  "contextualhelp.info": "Informace",
  "dialog.alert": "Výstraha",
  "dialog.dismiss": "Odstranit",
  "dropzone.replaceMessage": "Přetáhněte soubor k nahrazení",
  "inlinealert.informative": "Informace",
  "inlinealert.negative": "Chyba",
  "inlinealert.notice": "Varování",
  "inlinealert.positive": "Úspěch",
  "label.(optional)": "(volitelně)",
  "label.(required)": "(požadováno)",
  "menu.moreActions": "Další akce",
  "notificationbadge.indicatorOnly": "Nová aktivita",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Vybrat…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Načítání...",
  "table.loadingMore": "Načítání dalších...",
  "table.resizeColumn": "Změnit velikost sloupce",
  "table.sortAscending": "Seřadit vzestupně",
  "table.sortDescending": "Seřadit sestupně",
  "tag.actions": "Akce",
  "tag.hideButtonLabel": "Zobrazit méně",
  "tag.noTags": "Žádný",
  "tag.showAllButtonLabel": "Zobrazit vše ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
